import * as Sentry from '@sentry/react';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import {
  type GetFirmwareAdminSettingsResponse,
  getFirmwareAdminSettings,
} from 'api/admin/firmware/firmware';

const errorHandler = (error: unknown) => {
  Sentry.captureException(error);
};

export const useFirmwareAdminSettings = (): UseQueryResult<
  GetFirmwareAdminSettingsResponse,
  unknown
> => {
  return useQuery({
    queryKey: ['firmwareAdminSettings'],
    queryFn: async () => {
      const { data } =
        (await getFirmwareAdminSettings()) as AxiosResponse<GetFirmwareAdminSettingsResponse>;

      return data;
    },
    onError: errorHandler,
    retry: 1,
  });
};
